import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { flyingListApiReq, flyingListApiRes } from './interfaces'

class FlyingListApi implements apiInterface.IFlyingListApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getFlyingList = async (
    params: flyingListApiReq.IGetFlyListReq
  ): Promise<flyingListApiRes.IGetFlyingListRes[]> => {
    const res = await this.ctx.get<
      flyingListApiReq.IGetFlyListReq,
      flyingListApiRes.IGetFlyingListRes[]
    >('/order/fly_list_time_intervals/', params)

    return res.data
  }

  getInstructors = async (): Promise<flyingListApiRes.IGetInstructorsRes[]> => {
    const res = await this.ctx.get<unknown, flyingListApiRes.IGetInstructorsRes[]>('/instructor/')

    return res.data
  }

  updateFlyingListEntry = async (
    id: number,
    params: flyingListApiReq.IUpdateFlyingListEntryReq
  ): Promise<flyingListApiRes.IUpdateFlyingListEntryRes> => {
    const res = await this.ctx.patch<
      flyingListApiReq.IUpdateFlyingListEntryReq,
      flyingListApiRes.IUpdateFlyingListEntryRes
    >(`/order/fly_list_entries/${id}/`, params)
    return res.data
  }

  updateFlyingListTimeIntervals = async (
    id: number,
    params: flyingListApiReq.IUpdateFlyingListTimeIntervalsReq
  ): Promise<flyingListApiRes.IUpdateFlyingListTimeIntervalsRes> => {
    const res = await this.ctx.patch<
      flyingListApiReq.IUpdateFlyingListTimeIntervalsReq,
      flyingListApiRes.IUpdateFlyingListTimeIntervalsRes
    >(`/order/fly_list_time_intervals/${id}/`, params)
    return res.data
  }
}

export default FlyingListApi
